import React, { Component } from 'react'

import { Bar, Wrapper } from './styles'

class Loader extends Component {
  render() {
    return (
      <Wrapper fixed={this.props.fixed}>
        <Bar from={this.props.from} to={this.props.to} />
      </Wrapper>
    )
  }
}

export default Loader



// WEBPACK FOOTER //
// ./src/components/Loader/index.js